import { Card, Checkbox, Flex } from "antd"
import { EllipsisIcon } from "icons"
import { Text } from "ui/Typography"
import styles from "./clients.module.css"
import { memo, useCallback, useState } from "react"
import { formatPhoneNumber } from "utils/data-formatters"
import GroupTags from "pagesV2/pro/clients/GroupTags"
import { spacings } from "themes/variables"
import PropTypes from "prop-types"
import ActionDrawers from "./Drawers/ActionDrawer"
import BulkActions from "./ClientTable/BulkActions"

function ListingCard({ clients }) {
  const [open, setOpen] = useState(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])

  const showDrawer = useCallback(() => {
    setOpen(true)
  }, [])

  const handleSelectChange = (id, checked) => {
    if (checked) {
      setSelectedRowKeys((prev) => [...prev, id])
    } else {
      setSelectedRowKeys((prev) => prev.filter((key) => key !== id))
    }
  }

  const hasSelected = selectedRowKeys.length > 0

  return (
    <>
      {hasSelected && <BulkActions clients={clients} selectedRowKeys={selectedRowKeys} setSelectedRowKeys={setSelectedRowKeys} />}
      {clients?.map((client) => {
        const { user, client_groups, user_id } = client || {}
        const { phone_number, first_name, last_name, email } = user || {}
        return (
          <Card key={user_id} className={`w-full bg-surface-1 ${styles.listingCard}`}>
            <Flex gap={spacings.L} className="w-full" vertical>
              <Flex gap={spacings.M} align="center">
                <Checkbox
                  className={styles.hideOnMobile}
                  checked={selectedRowKeys.includes(user_id)}
                  onChange={(e) => handleSelectChange(user_id, e.target.checked)}
                />
                <Flex vertical gap={spacings.XS}>
                  <Flex>
                    <Text className={styles.label}>Name</Text> {first_name} {last_name}
                  </Flex>
                  <Flex>
                    <Text className={styles.label}>Email</Text>
                    <a className={"break-all"} href={`mailto:${email}`} onClick={(e) => e.stopPropagation()}>
                      {email}
                    </a>
                  </Flex>
                  <Flex>
                    <Text className={styles.label}>Phone</Text>
                    <a href={`tel:${phone_number}`} onClick={(e) => e.stopPropagation()}>
                      {formatPhoneNumber(phone_number)}
                    </a>
                  </Flex>
                  <Flex>
                    <Text className={styles.label}>Group</Text> <GroupTags groups={client_groups} />
                  </Flex>
                </Flex>
                <button
                  type="button"
                  onClick={showDrawer}
                  className="cursor-pointer ml-auto"
                  aria-label="More actions"
                  style={{ background: "none", border: "none", padding: 0 }}
                >
                  <EllipsisIcon fill="#525455" width={20} height={20} />
                </button>
              </Flex>
            </Flex>
          </Card>
        )
      })}
      {open && <ActionDrawers actionType="actions" open={open} setOpen={setOpen} />}
    </>
  )
}

ListingCard.propTypes = {
  clients: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      user: PropTypes.shape({
        phone_number: PropTypes.string,
        first_name: PropTypes.string,
        last_name: PropTypes.string,
        email: PropTypes.string
      }),
      client_groups: PropTypes.array
    })
  )
}

export default memo(ListingCard)
